// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"6b1a0ca4","110":"75711b4f","212":"5b6c5054","213":"b75b98df","248":"af306c26","511":"1270035e","515":"3172a617","631":"20031d98","660":"2690644f","722":"d384cdc2","761":"eb2296e3","770":"1b5841c5","803":"36932d3f","842":"80d2a566","877":"27a8604b"}[chunkId] + ".chunk.js";
};